import { ROUTES } from 'module/navigation/enums/routes.enums';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthForm } from '../components/AuthForm/AuthForm';
import { AuthLayout } from '../components/AuthLayout/AuthLayout';
import ChooseWorkplace from '../components/ChooseWorkplace/ChooseWorkplace';
import { useAuth } from '../context/AuthContext';

interface FormValues {
	email: string;
	password: string;
	organizationId: string;
}

export default function LoginPage(): JSX.Element {
	const auth = useAuth();
	const { push, location } = useHistory();
	const [view, setView] = useState('auth');
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (auth.isLoggedin()) {
			if (auth.isWorkplaceSelected()) {
				// if state exists that means its redirected from the app
				if (location.state) {
					setView('chooseworkplace');
				} else {
					push(ROUTES.DASHBOARD);
				}
			} else {
				setView('chooseworkplace');
			}
		} else {
			return;
		}
	}, []);

	const submitClick = async (data: FormValues) => {
		setIsLoading(true);
		try {
			const tenant = data.organizationId;
			delete data.organizationId;
			if (await auth.login({ ...data, tenant })) {
				setView('chooseworkplace');
			}
		} finally {
			setIsLoading(false);
		}
	};

	const chooseWorkplace = () => {
		push(ROUTES.DASHBOARD);
	};

	return (
		<AuthLayout>
			{view === 'auth' ? (
				<AuthForm submitClick={submitClick} isLoading={isLoading} />
			) : (
				<ChooseWorkplace chooseWorkplace={chooseWorkplace} />
			)}
		</AuthLayout>
	);
}
